import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import './index.css';
import { RouterProvider } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { router } from './routes/router';
import { PostHogProvider } from 'posthog-js/react';
import * as Sentry from '@sentry/react';
import Radar from 'radar-sdk-js';
import radarKey from './api/radar-config';

Sentry.init({
  // Set per deploy target in Render (build-time); unset disables the SDK
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  sendDefaultPii: true,
  environment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    'development',
  // Session Replay
  //integrations: [
  //  Sentry.replayIntegration()
  //],
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  integrations: [
    // send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
  ],
  enableLogs: true,
  enabled: import.meta.env.MODE === 'production',
});

try {
  Radar.initialize(radarKey);
} catch {
  // Radar SDK may throw in browsers with limited Permissions API support (e.g. iOS WKWebView)
}

const options = {
  api_host:
    import.meta.env.MODE === 'production'
      ? import.meta.env.VITE_PUBLIC_POSTHOG_HOST
      : '',
};

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 0 } },
});

createRoot(document.getElementById('hms-root') as HTMLElement).render(
  <PostHogProvider
    apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
    options={options}
  >
    <GoogleOAuthProvider
      clientId={import.meta.env.VITE_GOOGLE_SIGN_IN_CLIENT_ID}
    >
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </PostHogProvider>
);
